import { useEffect } from 'react';

const useDisablePageScroll = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked) return;

    const handleWheelEvent = (event: WheelEvent) => {
      let currentElement = event.target as HTMLElement | null;

      while (currentElement && currentElement !== document.body) {
        const computedStyle = getComputedStyle(currentElement);
        const { overflowY } = computedStyle;

        const elementCanScrollVertically =
          currentElement.scrollHeight > currentElement.clientHeight;

        const elementAllowsScroll =
          overflowY === 'auto' || overflowY === 'scroll';

        if (elementCanScrollVertically && elementAllowsScroll) {
          return;
        }

        currentElement = currentElement.parentElement;
      }

      event.preventDefault();
    };

    window.addEventListener('wheel', handleWheelEvent, { passive: false });

    return () => {
      window.removeEventListener('wheel', handleWheelEvent);
    };
  }, [isLocked]);
};

export default useDisablePageScroll;
